import AutosuggestPostalCode from './AutosuggestPostalCode';

export default AutosuggestPostalCode;
